import { useEffect, useState } from 'react';
import ModalComponent from 'v3/common/components/ModalComponent';
import { getStrykexKycStatus } from 'common/api/stockwiz';

interface KycStatusResponse {
  status: boolean;
  message: string;
  data?: boolean;
  error?: string;
}

const StockwizKycModal = () => {
  const [shouldShowModal, setShouldShowModal] = useState<boolean>(false);

  useEffect(() => {
    getStrykexKycStatus()
      .then((res: KycStatusResponse) => {
        if (res.status) {
          setShouldShowModal(!res.data);
        } else {
          setShouldShowModal(false);
        }
      })
      .catch(() => {
        setShouldShowModal(false);
      });
  }, []);

  if (!shouldShowModal) return null;

  return (
    <>
      <ModalComponent
        className="stockwiz-kyc-modal"
        title="Action Required"
        size="md"
        okBtnTitle="Complete KYC"
        onSave={() => {
          window.location.href = 'https://algo.stockwiz.in/kyc';
        }}
        onCancel={() => (window.location.href = '/users/sign_out')}
        cancelBtnTitle="Logout"
        shouldShow={shouldShowModal}
        shouldShowCloseButton={false}
      >
        <div className="stockwiz-kyc-modal__content">
          <h6>Updated KYC & Terms of Service</h6>
          <p>Action Required: Updated KYC & Terms of Service</p>
          <p>
            To comply with SEBI RA Regulations, 2014 and the Prevention of Money Laundering Act, 2002, please
            update your KYC details. This is a one time process, as it is mandatory as per SEBI rules to
            continue using research services.
          </p>
        </div>
      </ModalComponent>
    </>
  );
};

export default StockwizKycModal;
